import BetaGate from './BetaGate';

export default BetaGate;
